Mobi2Go.onReady(function() {
    let userLanguage =
        window.navigator.userLanguage || window.navigator.language;
    userLanguage.replace('-', '_');

    if (Mobi2Go.headoffice.facebook_sign_in_enabled) {
        const availableLocales = [
            'en_US',
            'ca_ES',
            'cs_CZ',
            'cx_PH',
            'cy_GB',
            'da_DK',
            'de_DE',
            'eu_ES',
            'en_UD',
            'es_LA',
            'es_ES',
            'gn_PY',
            'fi_FI',
            'fr_FR',
            'gl_ES',
            'hu_HU',
            'it_IT',
            'ja_JP',
            'ko_KR',
            'nb_NO',
            'nn_NO',
            'nl_NL',
            'fy_NL',
            'pl_PL',
            'pt_BR',
            'pt_PT',
            'ro_RO',
            'ru_RU',
            'sk_SK',
            'sl_SI',
            'sv_SE',
            'th_TH',
            'tr_TR',
            'ku_TR',
            'zh_CN',
            'zh_HK',
            'zh_TW',
            'af_ZA',
            'sq_AL',
            'hy_AM',
            'az_AZ',
            'be_BY',
            'bn_IN',
            'bs_BA',
            'bg_BG',
            'hr_HR',
            'nl_BE',
            'en_GB',
            'et_EE',
            'fo_FO',
            'fr_CA',
            'ka_GE',
            'el_GR',
            'gu_IN',
            'hi_IN',
            'is_IS',
            'id_ID',
            'ga_IE',
            'jv_ID',
            'kn_IN',
            'kk_KZ',
            'lv_LV',
            'lt_LT',
            'mk_MK',
            'mg_MG',
            'ms_MY',
            'mt_MT',
            'mr_IN',
            'mn_MN',
            'ne_NP',
            'pa_IN',
            'sr_RS',
            'so_SO',
            'sw_KE',
            'tl_PH',
            'ta_IN',
            'te_IN',
            'ml_IN',
            'uk_UA',
            'uz_UZ',
            'vi_VN',
            'km_KH',
            'tg_TJ',
            'ar_AR',
            'he_IL',
            'ur_PK',
            'fa_IR',
            'ps_AF',
            'my_MM',
            'qz_MM',
            'or_IN',
            'si_LK',
            'rw_RW',
            'cb_IQ',
            'ha_NG',
            'ja_KS',
            'br_FR',
            'tz_MA',
            'co_FR',
            'as_IN',
            'ff_NG',
            'sc_IT',
            'sz_PL',
        ];

        // If the user's locale is not one of the Facebook available locales, pick a reasonable alternative
        if (!availableLocales.includes(userLanguage)) {
            switch (Mobi2Go.app.language) {
                case 'en':
                    userLanguage = 'en_US';
                    break;
                case 'fr':
                    userLanguage = 'fr_FR';
                    break;
                case 'zh':
                    userLanguage = 'zh_CN';
                    break;
                case 'ar':
                    userLanguage = 'ar_AR';
                    break;
                case 'ja':
                    userLanguage = 'ja_JP';
                    break;
                case 'km':
                    userLanguage = 'km_KH';
                    break;
                case 'es':
                    userLanguage = 'es_ES';
                    break;
                case 'es-la':
                case 'es-MX':
                    userLanguage = 'es_LA';
                    break;
                default:
                    // U.S.A, U.S.A!!!! 🇺🇸
                    userLanguage = 'en_US';
                    break;
            }
        }

        (function(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = `https://connect.facebook.net/${userLanguage}/sdk.js#xfbml=0&version=v13.0&appId=${Mobi2Go.headoffice.facebook_app_id}&cookie=1`;
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    }

    if (Mobi2Go.headoffice.apple_sign_in_enabled) {
        const availableLocales = [
            'ar_SA',
            'ca_ES',
            'cs_CZ',
            'da_DK',
            'de_DE',
            'el_GR',
            'en_GB',
            'en_US',
            'es_ES',
            'es_MX',
            'fi_FI',
            'fr_CA',
            'fr_FR',
            'hr_HR',
            'hu_HU',
            'id_ID',
            'it_IT',
            'iw_IL',
            'ja_JP',
            'ko_KR',
            'ms_MY',
            'nl_NL',
            'no_NO',
            'pl_PL',
            'pt_BR',
            'pt_PT',
            'ro_RO',
            'ru_RU',
            'sk_SK',
            'sv_SE',
            'th_TH',
            'tr_TR',
            'uk_UA',
            'vi_VI',
            'zh_CN',
            'zh_HK',
            'zh_TW',
        ];

        // If the user's locale is not one of the apple available locales, pick a reasonable alternative
        if (!availableLocales.includes(userLanguage)) {
            switch (Mobi2Go.app.language) {
                case 'en':
                    userLanguage = 'en_US';
                    break;
                case 'fr':
                    userLanguage = 'fr_FR';
                    break;
                case 'zh':
                    userLanguage = 'zh_CN';
                    break;
                case 'ar':
                    userLanguage = 'ar_SA';
                    break;
                case 'ja':
                    userLanguage = 'ja_JP';
                    break;
                case 'km':
                    userLanguage = 'en_US';
                    break;
                case 'es':
                    userLanguage = 'es_ES';
                    break;
                case 'es-la':
                case 'es-MX':
                    userLanguage = 'es_MX';
                    break;
                default:
                    userLanguage = 'en_US';
                    break;
            }
        }
        Mobi2Go.helpers.loadScripts(
            [
                `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${userLanguage}/appleid.auth.js`,
            ],
            true,
            () => {
                AppleID.auth.init({
                    clientId: Mobi2Go.headoffice.apple_client_id,
                    scope: 'name email',
                    redirectURI: `https://${window.location.host}`,
                    state: 'Authenticationrequest',
                    usePopup: true,
                });
            }
        );
    }
});
